module.exports = __webpack_public_path__ + "img/Postmodernisme_Hanne-Orstavik.42afe5c0.jpg";